module.exports = __webpack_public_path__ + "system/img/calender.68e860ba.png";